import React from 'react';
import * as PropTypes from 'prop-types';
import ViaRoute from './ViaRoute';
import ViaSecuredRoute from './ViaSecuredRoute';
import ViaLayout from '../layout/ViaLayout';


export default function ViaEntryRoute({
  noAuth, titleKey, className, showFooter, ...rest
}) {
  return (
    <ViaLayout className={className} showHeader={!noAuth} showFooter={showFooter}>
      {
        noAuth
          ? <ViaRoute titleKey={titleKey} {...rest} />
          : <ViaSecuredRoute titleKey={titleKey} {...rest} />
      }
    </ViaLayout>
  );
}

ViaEntryRoute.propTypes = {
  noAuth: PropTypes.bool,
  titleKey: PropTypes.string,
  className: PropTypes.string,
  showFooter: PropTypes.bool,
};

ViaEntryRoute.defaultProps = {
  noAuth: false,
  titleKey: 'platformTitle',
  className: '',
  showFooter: true,
};
